import { Box, Checkbox, ListItem, Stack, Typography } from '@mui/material';
import { setAutocolonItem, setAutocolonSelectItem } from 'app/actions/transport';
import { Scrollbar } from 'app/components';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const GeofenceList = ({ setHaveUpdate }) => {
  const { autocolonSelectedItem } = useSelector((state) => state.transport);
  const geofenceCheckedId = autocolonSelectedItem?.geofenceItems || [];
  const dispatch = useDispatch();
  const { geofenceGroupItems } = useSelector((state) => state.map);
  const { geofenceSearchValue } = useSelector((state) => state.transport);
  const sortItems = useMemo(() => {
    if (geofenceSearchValue.length !== 0) {
      return geofenceGroupItems.filter(
        (geofenceGroup) => geofenceGroup.name.toLowerCase().indexOf(geofenceSearchValue.toLowerCase()) !== -1
      );
    }
    return geofenceGroupItems;
  }, [geofenceGroupItems, geofenceSearchValue]);

  const handleCheckboxSummaryClick = (e, key) => {
    if (!autocolonSelectedItem || autocolonSelectedItem.autocolons) return;
    e.preventDefault();
    e.stopPropagation();
    setHaveUpdate(true);
    const filterItems = sortItems[key].geofences.map((i) => i.id).filter((id) => geofenceCheckedId.indexOf(id) === -1);

    const checkedItems = geofenceCheckedId.filter((id) => sortItems[key].geofences.map((i) => i.id).indexOf(id) === -1);
    let geofenceItems = autocolonSelectedItem?.geofenceItems || [];
    if (filterItems.length) {
      geofenceItems = geofenceItems.concat(filterItems);
    } else {
      geofenceItems = checkedItems;
    }

    const newAutocolonItem = { ...autocolonSelectedItem, geofenceItems };
    dispatch(setAutocolonItem(newAutocolonItem));
    dispatch(setAutocolonSelectItem(newAutocolonItem));
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        '.simplebar-offset > div': {
          '&::-webkit-scrollbar': {
            width: 0,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
            boxShadow: 'none',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        },
      }}>
      <Stack
        direction='column'
        sx={(theme) => ({
          height: '100%',
          '.simplebar-content-wrapper': {
            padding: theme.spacing(0),
          },
          '.MuiAccordion-root': {
            borderRadius: '0',
            overflow: 'hidden',
            transition: 'background-color ' + theme.transitions.duration.shortest + 'ms ' + theme.transitions.easing.easeInOut + ' 0ms',
            '&:before': {
              display: 'none',
            },
            '&:last-of-type': {
              margin: '0!important',
            },
            '&.Mui-disabled': {
              bgcolor: 'background.paper',
              '.MuiAccordionSummary-root': {
                opacity: '1',
              },
              '.MuiAccordionSummary-expandIconWrapper': {
                display: 'none',
              },
            },
            '.MuiAccordionSummary-expandIconWrapper': {
              svg: {
                fontSize: '18px',
              },
            },
          },
          '.MuiAccordionSummary-root': {
            padding: theme.spacing(0, 2),
            minHeight: '24px',
            transition: 'none',
            '&:hover': {
              bgcolor: 'background.default',
              borderRadius: '0',
            },
            '&.Mui-expanded': {
              minHeight: '24px',
              bgcolor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              borderRadius: '0',
              '.MuiCheckbox-root': {
                color: '#FFFFFF',
                '&.Mui-checked': {
                  color: '#FFFFFF',
                },
              },
              '.MuiAccordionSummary-expandIconWrapper': {
                color: '#FFFFFF',
              },
            },
          },
          '.MuiAccordionSummary-content': {
            alignItems: 'center',
            overflow: 'hidden',
            margin: theme.spacing(0),
            '&.Mui-expanded': {
              margin: theme.spacing(0),
            },
            '.MuiCheckbox-root': {
              minWidth: '26px',
              justifyContent: 'flex-start',
              padding: theme.spacing(0),
              svg: {
                fontSize: '18px',
              },
            },
          },
          '.MuiAccordionDetails-root': {
            padding: theme.spacing(0),
            '.MuiList-root': {
              margin: '2px 0',
            },
          },
        })}>
        <Scrollbar>
          {sortItems.map(({ id, name, geofences }, key) => {
            const checkedFilter = geofences.filter((i) => geofenceCheckedId.indexOf(i.id) !== -1);

            return (
              <ListItem
                key={id}
                square
                elevation={0}
                disabled={geofences.length === 0}
                TransitionProps={{ unmountOnExit: true }}
                sx={{
                  padding: '0 12px',
                  height: '24px',
                  '&:hover': {
                    bgcolor: 'background.default',
                  },
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={(e) => handleCheckboxSummaryClick(e, key)}>
                  <Checkbox
                    size='small'
                    color='primary'
                    disableRipple
                    disabled={geofences.length === 0}
                    checked={geofences.length !== 0 && checkedFilter.length === geofences.length}
                    indeterminate={checkedFilter.length !== 0 && checkedFilter.length < geofences.length}
                  />
                  <Typography>
                    {name} ({geofences.length})
                  </Typography>
                </Box>
              </ListItem>
            );
          })}
        </Scrollbar>
      </Stack>
    </Box>
  );
};

export default GeofenceList;
